/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetSettings } from './TimesheetSettings';
import {
    TimesheetSettingsFromJSON,
    TimesheetSettingsFromJSONTyped,
    TimesheetSettingsToJSON,
    TimesheetSettingsToJSONTyped,
} from './TimesheetSettings';

/**
 * 
 * @export
 * @interface ShowTimesheetSettingsResponse
 */
export interface ShowTimesheetSettingsResponse {
    /**
     * 
     * @type {TimesheetSettings}
     * @memberof ShowTimesheetSettingsResponse
     */
    data: TimesheetSettings;
}

/**
 * Check if a given object implements the ShowTimesheetSettingsResponse interface.
 */
export function instanceOfShowTimesheetSettingsResponse(value: object): value is ShowTimesheetSettingsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowTimesheetSettingsResponseFromJSON(json: any): ShowTimesheetSettingsResponse {
    return ShowTimesheetSettingsResponseFromJSONTyped(json, false);
}

export function ShowTimesheetSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowTimesheetSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': TimesheetSettingsFromJSON(json['data']),
    };
}

  export function ShowTimesheetSettingsResponseToJSON(json: any): ShowTimesheetSettingsResponse {
      return ShowTimesheetSettingsResponseToJSONTyped(json, false);
  }

  export function ShowTimesheetSettingsResponseToJSONTyped(value?: ShowTimesheetSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimesheetSettingsToJSON(value['data']),
    };
}

